import React from "react";
import styles from "./AgentFloatingButton.module.scss";
import { useTranslation } from "react-i18next";
import { allMenus } from "../../../../i18n/namespace";
import { useDispatch } from "react-redux";


/**
 * AgentFloatingButton Component
 * 
 * This component renders a floating button with an icon and text. 
 * It triggers an action to open a widget when clicked.
 * 
 * Props:
 * - icon: React element representing the button icon.
 * - text: String key for translation to display button text.
 */
const AgentFloatingButton = ({ icon, text }) => {
    const { t } = useTranslation(allMenus);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch({
            type: "MENU:OPEN-WIDGET",
            payload: 'connectors'
        });
    };

    return (
        <button className={styles["agent-floating-btn"]} onClick={handleClick}>
            <span className={styles["agent-floating-btn-inner"]}>
                <span className={styles["agent-floating-btn-icon"]}>{icon}</span>
                <span className={styles["agent-floating-btn-text"]}>{t(text) || text}</span>
            </span>
        </button>
    );
};

export default AgentFloatingButton;
